import * as yup from 'yup';
import { PAN_REGEX, AADHAR_REGEX, GST_REGEX, MOBILE_REGEX } from '../utils/agencyProfileConstants';
/* ---------------------------
Reusable Social URL Validator
----------------------------*/
const socialUrl = (domain, message) =>
  yup
    .string()
    .nullable()
    .transform((v, o) => (o === '' || o === null ? null : v))
    .test("url-validation", message, (value) => {
      if (!value || typeof value !== 'string' || !value.trim()) return true;
      const regex = new RegExp(`^(https?:\\/\\/)?(www\\.)?${domain}(\\/.*)?$`, "i");
      return regex.test(value.trim());
    });

export const agencyProfileSchema = yup.object().shape({
    // Step 0: Personal
    yourName: yup.string().required('Name is required'),
    email: yup.string().email('Invalid email').required('Email required'),
    mobileNumber: yup.string().required('Mobile required'),
    alternateMobileNumber: yup
      .string()
      .nullable()
      .transform((v, o) => (o === '' ? null : v))
      .matches(MOBILE_REGEX, { message: 'Invalid mobile number', excludeEmptyString: true }),
    agencyName: yup.string().required('Agency Name required'),
    companyIncorporationDate: yup
      .date()
      .nullable()
      .transform((v, o) => (o === '' || o === null ? null : v))
      .typeError('Invalid date')
      .max(new Date(), "Future dates not allowed"),
    countryOfResidence: yup.object().shape({
      value: yup.string(),
      label: yup.string(),
    }).nullable().optional(), 
    specialization: yup.array().nullable().optional(),
    website: yup
      .string()
      .nullable()
      .transform((v, o) => (o === '' ? null : v))
      .url('Invalid Website URL'),
    aboutAgency: yup.string().nullable(),
    gstNumber: yup
      .string()
      .nullable()
      .transform((v, o) => (o === '' ? null : v))
      .matches(GST_REGEX, { message: 'Invalid GST Number', excludeEmptyString: true }),
    
    panNumber: yup
      .string()
      .nullable()
      .transform((v, o) => (o === '' ? null : v))
      .test(
        'pan-validation',
        'Invalid PAN Card format',
        (value) => !value || PAN_REGEX.test(value.toUpperCase())
      ),

    aadharNumber: yup
      .string()
      .nullable()
      .transform((v, o) => (o === '' ? null : v))
      .test(
        'aadhar-validation',
        'Aadhar must be 12 digits',
        (value) => !value || AADHAR_REGEX.test(value)
      ),

    // Step 1: Address
    addressType: yup.string().nullable(),
    pinCode: yup
      .string()
      .nullable()
      .transform((v, o) => (o === '' ? null : v))
      .test("pincode-check", "Pin Code must be 6 digits", (val) => !val || /^\d{6}$/.test(val)),
    addressLine1: yup.string().nullable(),
    addressLine2: yup.string().nullable(),
    state: yup.string().nullable(),
    district: yup.string().nullable(),

    // Step 2: Team Members (Optional)
    teamMembers: yup.array().of(yup.object().shape({
        name: yup.string().nullable(),
        email: yup.string().email('Invalid email').nullable(),
        mobile: yup.string().nullable(),
        designation: yup.object().nullable(),
        contactType: yup.object().nullable(),
    })).nullable().optional(),

    // Step 3: Social
    facebookProfileUrl: socialUrl("facebook\\.com", "Enter valid Facebook URL"),
    linkedinProfileUrl: socialUrl("linkedin\\.com", "Enter valid LinkedIn URL"),
    instagramProfileUrl: socialUrl("instagram\\.com", "Enter valid Instagram URL"),
    twitterProfileUrl: socialUrl("(x\\.com|twitter\\.com)", "Enter valid Twitter/X URL"),
    youtubeUrl: socialUrl("(youtube\\.com|youtu\\.be)", "Enter valid YouTube URL"),
    imdbUrl: socialUrl("imdb\\.com", "Enter valid IMDB URL"),
    whatsappNo: yup
      .string()
      .nullable()
      .transform((v, o) => (o === '' ? null : v))
      .matches(MOBILE_REGEX, { message: 'Invalid WhatsApp Number', excludeEmptyString: true }),
});